export enum InvoiceChannel {
    EMAIL = 'EMAIL',
    MAIL = 'MAIL',
    ELECTRONIC_INVOICE = 'ELECTRONIC_INVOICE',
    EDIFACT = 'EDIFACT',
    PAPER_INVOICE = 'PAPER_INVOICE',
    NO_SENDING = 'NO_SENDING',
}
